import { render } from "./ilnostroimpegno.vue?vue&type=template&id=c1249e66&bindings={\"navigate\":\"props\"}"
import script from "./ilnostroimpegno.vue?vue&type=script&lang=js"
export * from "./ilnostroimpegno.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./ilnostroimpegno.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script